import { Button } from "primereact/button";
import {
  genElDate,
  genElObject,
} from "../../../../../components/utils/HeaderElementGenerator";
import KendaraanSelectorDialog from "../../../../../dialogs/selectors/KendaraanSelectorDialog";
import { useState } from "react";
import extractUrlParams from "../api/extract-url-params";

const Filter = (props) => {
  const { loading, onReload, onNew, filterValue, setFilterValue } = props;

  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);

  // handle ui event section

  const handleOnClickKendaraan = () => {
    setShowKendaraanSelector(true);
  };

  const handleOnConfirmKendaraan = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setFilterValue({ ...filterValue, data_kendaraan: selected });
      setShowKendaraanSelector(false);
    }
    return selected;
  };

  // custom ui section

  const filterElDari = genElDate({
    field: "dari",
    name: "Dari",
    data: filterValue,
    setData: setFilterValue,
    width: "w-[18rem]",
  });

  const filterElSampai = genElDate({
    field: "sampai",
    name: "Sampai",
    data: filterValue,
    setData: setFilterValue,
    width: "w-[18rem]",
  });

  const filterElVehicle = genElObject({
    name: "Kendaraan",
    field: "data_kendaraan",
    value:
      filterValue && filterValue.data_kendaraan
        ? `${filterValue.data_kendaraan.nomor_polisi} | ${filterValue.data_kendaraan.jenis_mobil}`
        : "",
    width: "w-[18rem]",
    onClick: handleOnClickKendaraan,
    onClear: () => setFilterValue({ ...filterValue, data_kendaraan: null }),
  });

  return (
    <div className="elevated-card w-100 gap-3 row-between-center">
      <KendaraanSelectorDialog
        title={"Pilih Kendaraan"}
        visible={showKendaraanSelector}
        additionalFilter="data_kendaraan_jenis.nama:!=:Trado"
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />

      <div className="row-between-center w-full flex-wrap gap-5">
        {/* header filter  */}
        <div className="row-start-center gap-4 wrap">
          {filterElVehicle}
          {filterElDari}
          {filterElSampai}
        </div>
        {/* header control buttons  */}
        <div className="row-end-center gap-2 w-full md:w-fit">
          {/* <Button
                icon="pi pi-trash"
                size="small"
                severity="danger"
                rounded
                outlined
              /> */}
          <Button
            icon="pi pi-plus"
            size="small"
            severity="success"
            onClick={onNew}
            rounded
            outlined
          />
          <Button
            icon="pi pi-refresh"
            size="small"
            loading={loading}
            onClick={onReload}
            rounded
            outlined
          />
        </div>
      </div>
    </div>
  );
};

export default Filter;
